import { render, staticRenderFns } from "./NoLearningNeededBanner.vue?vue&type=template&id=4759a21d&scoped=true"
import script from "./NoLearningNeededBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./NoLearningNeededBanner.vue?vue&type=script&setup=true&lang=js"
import style0 from "./NoLearningNeededBanner.vue?vue&type=style&index=0&id=4759a21d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4759a21d",
  null
  
)

export default component.exports